import {
  api_get_customer_list_url,
  api_create_customer_url,
  api_update_customer_url,
  api_activate_deactivate_customer_url,
  api_get_customer_details_url
} from "./customerApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  parser_get_customer_list,
  parser_create_customer,
  parser_update_customer,
  parser_activate_deactivate_customer,
  parser_get_customer_details
} from "./customerParser";
import { PAGE } from "../../helpers/constants";

export const get_customer_list = createAsyncThunk(
  "customer",
  async (payload) => {
    try {
      const { page, limit, qn, qs } = payload;
      const response = await api_get_customer_list_url(page, limit, qn, qs);
      const data = parser_get_customer_list(response);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  }
);


export const create_customer = createAsyncThunk(
  "create_customer",
  async (payload) => {
    try {
      const { company_name, special_instructions } = payload
      const formData = new FormData();
      formData.append("company_name", company_name);
      if (special_instructions !== undefined && special_instructions !== null) {
        formData.append("special_instructions", special_instructions);
      }
      
      const response = await api_create_customer_url(formData);
      const data = parser_create_customer(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const update_customer = createAsyncThunk(
  "update_customer",
  async (payload) => {
    try {
      const { customer_id, updated_data } = payload
      const formData = new FormData();
      if (updated_data.company_name) {
        formData.append("company_name", updated_data.company_name);
      }
      if (updated_data.special_instructions !== undefined && updated_data.special_instructions !== null) {
        formData.append("special_instructions", updated_data.special_instructions);
      }
      if (updated_data.is_active !== undefined) {
        formData.append("is_active", updated_data.is_active);
      }
      const response = await api_update_customer_url(customer_id, formData);
      const data = parser_update_customer(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const activate_deactivate_customer = createAsyncThunk(
  "activate_deactivate_customer",
  async (payload) => {
    try {
      const { customer_id, updated_data } = payload
      const response = await api_activate_deactivate_customer_url(customer_id, updated_data)
      const data = parser_activate_deactivate_customer(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_customer_details = createAsyncThunk(
  "get_customer_details",
  async (payload) => {
    try {
      const response = await api_get_customer_details_url(payload);
      const data = parser_get_customer_details(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

const initialState = {
  common_loading: false,
  is_customer_modal_open: false,
  selected_status: '',
  search_query: '',
  selected_data: null,
  c_action: null,
  customer_id: null,
  customer_list: [],
  total_customer_count: 0,
  active_customer: 0,
  page: PAGE - 1
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomerPage: (state, action) => {
      state.page = action.payload;
    },
    setCustomerModalOpen: (state, action) => {
      state.is_customer_modal_open = action.payload;
    },
    setAction: (state, action) => {
      state.c_action = action.payload;
    },
    setId: (state, action) => {
      state.customer_id = action.payload;
    },
    setStatus: (state, action) => {
      state.selected_status = action.payload ? action.payload : '';
    },
    setSearchQuery: (state, action) => {
      state.search_query = action.payload;
    }
  },
  extraReducers: (builder) => {
    // get customer list
    builder.addCase(get_customer_list.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_customer_list.fulfilled, (state, action) => {
      state.common_loading = false;
      const customerData = Array.isArray(action.payload.customers) ? action.payload.customers : [];
      state.customer_list = customerData;
      state.total_customer_count = action.payload.total_count || customerData.length;
      state.active_customer = customerData.filter(customer => customer.is_active).length;
    })
    builder.addCase(get_customer_list.rejected, (state) => {
      state.common_loading = false;
    })
    //create customer
    builder.addCase(create_customer.fulfilled, (state, action) => {
      state.common_loading = false;
      if (action.payload?.data) {
        state.customer_list.push(action.payload.data);
        state.total_customer_count = state.customer_list.length;
        state.active_customer = state.customer_list.filter(customer => customer.is_active).length;
      }
    });
    //update customer
    builder.addCase(update_customer.fulfilled, (state, action) => {
      state.common_loading = false;
      state.customer_list = state.customer_list.map((customer) =>
        customer.id === action.payload.data.id ? { ...customer, ...action.payload.data } : customer
      );
      state.total_customer_count = state.customer_list.length;
      state.active_customer = state.customer_list.filter(customer => customer.is_active).length;
    });
    // activate_deactivate_customer
    builder.addCase(activate_deactivate_customer.fulfilled, (state, action) => {
      state.common_loading = false;
      state.customer_list = state.customer_list.map((customer) =>
        customer.id === action.payload.data.id ? { ...customer, ...action.payload.data } : customer
      );
      state.total_customer_count = state.customer_list.length;
      state.active_customer = state.customer_list.filter(customer => customer.is_active).length;
    });
    //get customer details
    builder.addCase(get_customer_details.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_customer_details.fulfilled, (state, action) => {
      state.common_loading = false;
      state.selected_data = action.payload.data
    })
    builder.addCase(get_customer_details.rejected, (state) => {
      state.common_loading = false;
    })
  },
});

// Action creators are generated for each case reducer function
export const {
  setCustomerModalOpen,
  setCustomerPage,
  setAction,
  setId,
  setStatus,
  setSearchQuery
} = customerSlice.actions;
export default customerSlice.reducer;
